<!--====================================
=            DRAWER-VERTICAL            =
=====================================-->
<template>
  <div class="scrollbar scrollbar-primary">
    <v-list dark>
      <v-list-item link>
        <v-list-item-content>
          <v-list-item-title class="text-center">
            <img style="width:200px" src="../../assets/images/logo1.png">
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list dark shaped>
      <v-list-group v-for="item in items" :key="item.group" v-if="item.action" active-class="primary white--text">
        <template v-slot:activator>
          <v-list-item-icon class="ml-2" color="primary">
            <v-icon v-text="item.action"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2" dark v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" :to="{ path: '/' + subItem.path }" link>

          <v-list-item-content link>

            <v-list-item-title class="text-caption text-center white--text " v-text="subItem.title">
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>
<script>
  import menu from "../../util/menu.js";
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      isActive: true,
      active: true,
      mini: false,
      navbar: true,
      items: menu,
      bottomNav: "recent",
    }),
    methods: {
      goGroup(x, y) {
        let vm = this;
        vm.$router.push(`/${x}/${y}`);
      },
      goPage(x, y) {
        let vm = this;
        vm.$router.push(`/${x}/${y}`);
      },
    },

  };
</script>
<style>
  .menu-list {
    font-size: 12px;
  }

  .menu-title {}

  .base-drawer {
    height: 100% !important
  }
</style>


<!--====  End of DRAWERVERTICAL  ====-->